// @ts-nocheck
// inheritance doesn't override toolkit utilities and we need to to get gridGapStyles from the store theme instead of the toolkit 
// theme as a style in gridgapstyles is messing up responsiveness in some components on mobile. 
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { gridGapStyles } from "@store/Themes/common/mixins";
import { GridPreset } from "@toolkit/Framework/Types/Grid";

export const getGridPresetStyles = (preset: GridPreset) => {
    return gridGapStyles(preset.horizontal, preset.vertical);
};

export const getGridPreset = (preset: GridPreset): GridContainerProps => ({
    gap: 0,
    css: getGridPresetStyles(preset),
});
